import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";

interface Year {
  id?: number;
  year?: number;
}

interface YearFilterSelectProps {
  years: Year[];
  selectedYearIds: number[];
  onChange: (yearIds: number[]) => void;
  label?: string;
  fullWidth?: boolean;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
}

export const YearFilterSelect: React.FC<YearFilterSelectProps> = ({
  years,
  selectedYearIds,
  onChange,
  label = "Years",
  fullWidth = true,
  size = "small",
  sx,
}) => {
  const handleChange = (e: SelectChangeEvent<number[]>) => {
    const value = e.target.value as number[];
    onChange(value);
  };

  return (
    <FormControl fullWidth={fullWidth} size={size} sx={sx}>
      <InputLabel shrink={true}>{label}</InputLabel>
      <Select
        multiple
        notched={true}
        value={selectedYearIds}
        displayEmpty
        onChange={handleChange}
        label={label}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return "All Years";
          }

          if (selected.length > 3) {
            return `${selected.length} years selected`;
          }

          return selected
            .map((id) => years.find((y) => y.id === id)?.year)
            .join(", ");
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {years.map((year) => (
          <MenuItem key={year.id} value={year.id}>
            <Checkbox
              checked={
                year.id !== undefined && selectedYearIds.indexOf(year.id) > -1
              }
            />
            <ListItemText primary={year.year} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
